<div class="form-grid-layout" *ngIf="form">
  <div fxLayout="row" fxLayoutGap="20px" [formGroup]="form">
    <div class="input-container" fxFlex="0 1 35%">
      <label *ngIf="!hideLabels && labels">
        {{ labels.name }}
        <mat-icon-button
          class="btn-hint"
          matTooltip="These components can have generic or chemical names."
        >
          <mat-icon class="help-icon">help</mat-icon>
        </mat-icon-button>
      </label>
      <mat-form-field>
        <input maxlength="150" matInput formControlName="name" />
        <mat-error *ngIf="errorHandling('name')">
          {{ getSampleErrorMessage('name', 'Component Name') }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="input-container" fxFlex="0 1 25%">
      <label *ngIf="!hideLabels && labels">
        {{ labels.typicalOrActual }}
      </label>
      <mat-form-field>
        <input
          digitalPlatformFourDigitDecimaNumber
          matInput
          formControlName="typicalOrActual"
        />
        <span *ngIf="!showPpm" style="padding: 5px" matSuffix>%</span>

        <mat-error *ngIf="errorHandling('typicalOrActual')">
          {{ getSampleErrorMessage('typicalOrActual', 'Typical / Actual %') }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="input-container" fxFlex="0 1 15%">
      <label *ngIf="!hideLabels && labels">
        {{ labels.min }}
      </label>
      <mat-form-field>
        <input maxlength="3" matInput formControlName="min" />
        <span style="padding: 5px" matSuffix>%</span>
        <mat-error *ngIf="errorHandling('min')">
          {{ getSampleErrorMessage('min', 'Low %') }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="input-container" fxFlex="0 1 15%">
      <label *ngIf="!hideLabels && labels">
        {{ labels.max }}
      </label>
      <mat-form-field>
        <input maxlength="3" matInput formControlName="max" />
        <span style="padding: 5px" matSuffix>%</span>
        <mat-error *ngIf="errorHandling('max')">
          {{ getSampleErrorMessage('max', 'High %') }}
        </mat-error>
      </mat-form-field>
    </div>

    <div
      *ngIf="showPpm"
      class="input-container"
      fxFlex="0 1 10%"
      [ngStyle]="isRequired && { 'padding-top': '2rem' }"
    >
      <div>
        <mat-form-field>
          <mat-select formControlName="unitOfMeasure">
            <mat-option *ngFor="let option of select" [value]="option.code">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
